import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetVirtualMetricInstancesCB} from "../../ope/virtualmetric/GetVirtualMetricInstancesCB";
import {GetVirtualMetricsCB} from "../../ope/virtualmetric/GetVirtualMetricsCB";
import {PutVirtualMetricCB} from "../../ope/virtualmetric/PutVirtualMetricCB";
import {DelVirtualMetricCB} from "../../ope/virtualmetric/DelVirtualMetricCB";
import {DuplicateVirtualMetricCB} from "../../ope/virtualmetric/DuplicateVirtualMetricCB";
import {CheckVirtualMetricExpressionCB} from "../../ope/virtualmetric/CheckVirtualMetricExpressionCB";

@Injectable({
  providedIn: 'root'
})
export class VirtualmetricOpeService extends BaseOPEService {

  public getVirtualMetricInstances(cb: GetVirtualMetricInstancesCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getVirtualMetrics(cb: GetVirtualMetricsCB): Promise<any> {
    return this.execOPE(cb)
  }

  public putVirtualMetric(cb: PutVirtualMetricCB): Promise<any> {
    return this.execOPE(cb);
  }

  public duplicateVirtualMetric(cb: DuplicateVirtualMetricCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delVirtualMetric(cb: DelVirtualMetricCB): Promise<any> {
    return this.execOPE(cb);
  }

  public checkVirtualMetricExpression(cb: CheckVirtualMetricExpressionCB): Promise<any> {
    return this.execOPE(cb);
  }

}
